module.exports = __webpack_public_path__ + "04b115dfb0bbd3f1099fb598bab64c6c.svg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/img/fullscreen-btn_img.svg
// module id = 1678
// module chunks = 2